export const $window = $(window);
export const $document = $(document);
export const $body = $('body');
export const activeClass = 'is-active';

